import UIFx from 'uifx';
// @ts-ignore
import audioFile from '../../../../skin/sounds/new-chat-message.mp3';
import {ITEM_VIEW_CHAT, ITEM_VIEW_DISCUSSION, ItemViewType} from "../../gd/app-manager/item-view";
import {
    EVENT_BUS_CHAT_COUNTER_UPDATE,
    EVENT_BUS_CHAT_NEW_MESSAGE,
    EVENT_BUS_SESSION_CHATS_CHANGE
} from "../../model2/chat/chat/const";
import SessionEventProto from "../session-event-proto";
import ChatMessage from "../../model2/chat/chat-message/chat-message";

export default class SessionEvent_ChatMessageNew extends SessionEventProto {

    constructor(sessionEvent:any) {
        super(sessionEvent)
    }

    async process() {

        // ignore if from different company (!)
        if (this.isDifferentCompany()) return false;

        let chat            = gd.session.chats ? gd.session.chats.get(this.data.chatId) : null;
        const selfMessage    = this.data.userId === gd.session.me.id;
        const chatItemView            = gd.itemView.findByContainerId(ItemViewType.ITEM_VIEW_CHAT);
        const discussionItemView      = gd.itemView.findByContainerId(ItemViewType.ITEM_VIEW_DISCUSSION);
        const chatView      = gd.getApp()

        // i.e. check if we have this chat open
        const addMessageToChatView =
            (chatItemView && chatItemView.app.chatId === this.data.chatId) || // chatView app
            (discussionItemView && discussionItemView.app.controller.id === this.data.chatId) || // discussionView app
            // @ts-ignore
            (chatView && chatView.chatId === this.data.chatId)   // chat app

        if (addMessageToChatView) {
            // show message in chat...
            gd.bus.triggerEvent(EVENT_BUS_CHAT_NEW_MESSAGE, new ChatMessage(this.data));
            // gd.bus.triggerEvent(EVENT_BUS_CHAT_NEW_MESSAGE, this.data);
        } else if (!selfMessage) {
            // update counter
            gd.session.counters.increaseChatNewMessagesCount();
        }

        // Experimental play sound notification
        if (!selfMessage) this.playSound();
        if (!selfMessage && !addMessageToChatView) this.showNotification();

        if (chat) {
            // Increase counter
            if (!addMessageToChatView && !selfMessage) chat.newMessages++;
            gd.bus.triggerEvent(EVENT_BUS_CHAT_COUNTER_UPDATE, this.data);

            // Update lastMessage & momentLastUpdated
            chat.momentLastUpdated  = moment();
            chat.lastMessage        = this.data.message
            gd.bus.triggerEvent(EVENT_BUS_SESSION_CHATS_CHANGE, this.data);

        }
    }

    showNotification() {
        if (!gd.session.me.clientData.notifications.chat.growl) return;

        if (this.data.systemType === 1) { // new txt message
            gd.growl.chatMessage(this.data.chatId, this.data.userId, this.data.message);
        }
    }

    playSound() {
        if (!gd.session.me.clientData.notifications.chat.sound) return;

        const bell = new UIFx(
            audioFile,
            {
                volume: 0.8, // number between 0.0 ~ 1.0
                throttleMs: 100
            }
        );
        bell.play();
    }
};